import React from 'react';

export default function Loader() {
  return (
    <div className='flex justify-center items-center h-screen w-full '>
      <div class='loader '></div>
    </div>
  );
}
